import chroma from 'chroma-js'

export default chroma
